export default __webpack_public_path__ + "static/media/double-selected.b7497310.svg";